import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import _ from "lodash";
import { Sentiment } from "stores/ApplicationFilters/Filters/Sentiment";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

function isSentiment(value: unknown): value is Sentiment {
    return (
        value === Sentiment.Positive ||
        value === Sentiment.Neutral ||
        value === Sentiment.Negative
    );
}

export const SentimentChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const value = _.get(applicationFiltersStore, props.item.filterKey);
    if (value === undefined || value === null) return null;
    if (!isSentiment(value)) {
        console.error("Invalid sentiment value provided to sentiment chip");
        return null;
    }

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                // @ts-expect-error
                applicationFiltersStore.resetByKey(props.item.filterKey)
            }
        >
            {props.item.title}: {Sentiment.toString(value)}
        </AppliedFilterChip>
    );
});
